import { Flex, useColorMode, useColorStyle } from '@tonic-one/react';
import React from 'react';

import { useSiderWidthStore } from '../../../models/useSiderWidthModel';
import MiniPagination from '../MiniPagination';

interface Props {
  totalCount: number;
  currentPage: number;
  pageSize: number;
  changeCurrentPage: (page: number) => void;
  changePageSize: (size: number) => void;
  iconWithTip?: boolean;
  tip?: string;
}

function BottomPagination({
  totalCount,
  currentPage,
  pageSize,
  changeCurrentPage,
  changePageSize,
  iconWithTip,
  tip,
}: Props) {
  const { siderWidth } = useSiderWidthStore();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  return (
    <Flex
      position="fixed"
      pr="2x"
      zIndex="800"
      bottom={0}
      left={siderWidth}
      right={0}
      background={colorStyle.background.secondary}
      height={48}
      align="center"
      justify="flex-end"
    >
      <MiniPagination
        totalCount={totalCount}
        currentPage={currentPage}
        pageSize={pageSize}
        changeCurrentPage={changeCurrentPage}
        changePageSize={changePageSize}
        iconWithTip={iconWithTip}
        tip={tip}
      />
    </Flex>
  );
}

export default React.memo(BottomPagination, (pre, cur) => {
  return (
    pre.totalCount === cur.totalCount &&
    pre.currentPage === cur.currentPage &&
    pre.pageSize === cur.pageSize
  );
});
